import { defineAsyncComponent } from 'vue'
export default {
  admin: defineAsyncComponent(() => import("/home/runner/_work/mono/mono/out/apps/web/app/layouts/admin.vue").then(m => m.default || m)),
  "full-screen": defineAsyncComponent(() => import("/home/runner/_work/mono/mono/out/apps/web/app/layouts/full-screen.vue").then(m => m.default || m)),
  "side-nav": defineAsyncComponent(() => import("/home/runner/_work/mono/mono/out/apps/web/app/layouts/side-nav.vue").then(m => m.default || m))
}